import { APPOINTMENT_TZ } from './token.constants.js';

const ISO_DATE_LENGTH = 10;

/**
 * Liefert den heutigen Kalendertag als ISO-String `YYYY-MM-DD` aus Sicht der
 * Praxis-Zeitzone (`APPOINTMENT_TZ`).
 *
 * Begründung Berlin statt UTC (Code-Review DEV-014, W1): Direkt nach
 * Mitternacht (z.B. 00:30 lokal) liefert UTC noch den Vortag — der
 * `<input type="date">`-Picker bekäme dann einen `max`-Wert, der einen
 * Tag hinter dem realen Heute liegt. Konsistenz mit `formatAppointment`
 * (`Intl.DateTimeFormat` mit `timeZone: 'Europe/Berlin'`).
 *
 * @param now Optionaler Referenz-Zeitpunkt für Tests (Default `Date.now()`).
 */
export function todayIso(now: number = Date.now()): string {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: APPOINTMENT_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  return formatter.format(new Date(now)).slice(0, ISO_DATE_LENGTH);
}
